const BLOCK_LABELS: Record<string, string> = {
  stat: "Key metrics",
  bars: "Distribution",
  entities: "Entity list",
  timeline: "Timeline",
  callout: "Insight",
  compare: "Comparison",
  kpi: "Key metrics",
  gauge: "Composition",
  scatter: "Opportunity matrix",
  property: "Property details",
};

interface BlockPlaceholderProps {
  type: string;
}

export function BlockPlaceholder({ type }: BlockPlaceholderProps) {
  const label = BLOCK_LABELS[type] ?? "Loading";

  return (
    <div className="cx-block-placeholder">
      <span className="cx-block-placeholder-label">{label}</span>
    </div>
  );
}
